import assert from 'http-assert-plus';

export function getDemoOverrides() {
  const origin = process.env.VUE_ENV === 'client' ? (process.env.PROXY_API_URL || window.location.origin) : null;
  assert(typeof origin === 'string', 'Expected origin to be a string');
  switch (`${origin}`.substr(8, `${origin}`.indexOf('.demo.reallinks.') - 8)) {
    case 'referrals': case 'referrals-employee': case 'referrals-recruiter': return options.REFERRALS;
    case 'im': case 'im-employee': case 'im-recruiter': return options.IM;
    case 'share': case 'share-employee': case 'share-recruiter': return options.SHARE;
    default: return options.COMBINED;
  }
}

const options = {
  REFERRALS: {
    i18n: {
      'en:auth.register.info.title': 'Employee referrals made simple!',
      'en:auth.register.info.content': [
        'Refer your connections quickly and easily though our easy sharing & search features',
        'Earn points & prizes for contributing to your referral scheme',
        'Help your company find great candidates and your friends find great roles',
      ],
    },
  },
  IM: {
    i18n: {
      'en:auth.register.info.title': 'Internal Mobility made simple!',
      'en:auth.register.info.content': [
        'Let the platform match you to internal opportunities that support your growth',
        'Take control of your career path by highlighting the roles and skills you want to achieve',
        'Find or become a mentor to help you and your colleagues career development',
        'Proactively improve and develop new skills taking on internal projects',
      ],
    },
    branding: {
      onboarding: [
        { name: 'skills' },
        { name: 'interest' },
        { name: 'mentorship' },
      ],
    },
  },
  COMBINED: {
    i18n: {
      'en:auth.register.info.title': 'Employee Referrals & Internal Mobility made simple!',
      'en:auth.register.info.content': [
        'Let the platform match you to internal opportunities that support your growth',
        'Refer your connections quickly and easily though our easy sharing & search features',
        'Take control of your career path by highlighting the roles and skills you want to achieve',
        'Find or become a mentor to help you and your colleagues career development',
        'Proactively improve and develop new skills taking on internal projects',
      ],
    },
    branding: {
      onboarding: [
        { name: 'skills' },
        { name: 'interest' },
        { name: 'mentorship' },
      ],
    },
  },
  SHARE: {
    i18n: {
      'en:auth.register.info.title': 'Employee referrals made simple!',
      'en:auth.register.info.content': [
        'Start receiving referral recommendations automatically when your connections are matched to jobs',
        'Refer your connections quickly and easily though our easy sharing features',
        'Earn points & prizes for contributing to your referral scheme',
        'Help your company find great candidates and your friends find great roles',
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/lib/demo.js